import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { WidgetPublish } from "@/components/widget-publish";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useWidgetStore } from "@/stores/widget-store";
import { Input } from "../ui/input";
import { Link as LinkIcon } from "lucide-react";

export const SettingsTab = () => {
  const { config, setStatus, setStatementUrl, setStatementEnabled } = useWidgetStore();
  const statement = useWidgetStore((state) => state.config.modules.statement);

  return (
    <div className="cy:max-w-7xl cy:mx-auto cy:px-4 cy:sm:px-6 cy:lg:px-8 cy:pt-8">
      <Card className="cy:rounded-lg cy:gap-0 cy:shadow-none!">
        <CardHeader className="cy:border-b cy:border-gray-200 cy:pb-6">
          <CardTitle className="cy:text-xl">General settings</CardTitle>
          <CardDescription>
            Control your widget's visibility and link your accessibility
            statement.
          </CardDescription>
          <CardAction>
            <WidgetPublish />{" "}
          </CardAction>
        </CardHeader>
        <CardContent className="cy:p-0">
          <div className="cy:max-w-7xl cy:mx-auto cy:px-4 cy:sm:px-6 cy:lg:px-8">
            <div className="cy:flex cy:flex-col cy:gap-4 cy:border-b cy:border-gray-200 cy:py-6">
              <div className="cy:flex cy:items-center cy:justify-between cy:space-x-2">
                <Label htmlFor="cy-toggle-widget-desktop" className="cy:text-base! cy:font-normal! cy:text-foreground!">Enable widget on desktop</Label>
                <Switch id="cy-toggle-widget-desktop" checked={config.status.desktop} onCheckedChange={(checked) => setStatus({ ...config.status, desktop: checked })}    />
              </div>
            </div>
            <div className="cy:flex cy:flex-col cy:gap-4 cy:border-b cy:border-gray-200 cy:py-6">
              <div className="cy:flex cy:items-center cy:justify-between cy:space-x-2">
                <Label htmlFor="cy-toggle-widget-mobile" className="cy:text-base! cy:font-normal! cy:text-foreground!">Enable widget on mobile layouts</Label>
                <Switch id="cy-toggle-widget-mobile" checked={config.status.mobile} onCheckedChange={(checked) => setStatus({ ...config.status, mobile: checked })}    />
              </div>
            </div>
            <div className="cy:flex cy:flex-col cy:gap-4 cy:py-6">
              <div className="cy:flex cy:items-center cy:justify-between cy:space-x-2">
                <Label htmlFor="cy-toggle-accessibility-statement" className="cy:text-base! cy:font-normal! cy:text-foreground!">Link accessibility statement on widget</Label>
                <Switch id="cy-toggle-accessibility-statement" checked={statement.enabled} onCheckedChange={(checked) => setStatementEnabled(checked)}    />
              </div>
              <div className="cy:flex cy:flex-col cy:gap-4 cy:items-start cy:justify-between cy:space-x-2 cy:pt-4">
                <Label htmlFor="cy-toggle-accessibility-statement-url" className="cy:text-base! cy:font-normal! cy:text-foreground!">Accessibility statement URL</Label>
                <div className="cy:relative cy:w-1/2">
                  <Input 
                    id="cy-toggle-accessibility-statement-url" 
                    value={statement.url} 
                    onChange={(e) => setStatementUrl(e.target.value)} 
                    placeholder="E.g., yoursite.com/accessibility"
                    className="cy:w-full cy:border! cy:rounded! cy:h-[48px] cy:pl-10" 
                  />
                  <LinkIcon className="cy:absolute cy:left-3 cy:top-1/2 cy:-translate-y-1/2 cy:text-gray-400 cy:w-5 cy:h-5" />
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
